const MAX_FILE_SIZE_MB = 12;
const KILOBYTE = 1024;

export const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_KEY;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * KILOBYTE * KILOBYTE;
export const ACCEPT_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
];
export const ACCEPT_IMAGE_TYPES_STRING = ACCEPT_IMAGE_TYPES.join(", ");
export const HEIC_EXTENSIONS = ["heic", "heif"];
export const ERROR_MSG = {
  FILE_SIZE_TOO_LARGE: `選択できる画像のファイルサイズは${MAX_FILE_SIZE_MB}MB未満となります。`,
  INVALID_IMAGE_TYPE: "対応していない画像タイプです。",
};

export const DRINK_TYPE = {
  1: "強い",
  2: "普通",
  3: "弱い",
  4: "飲めない",
  "": "未選択",
};

export const LOGIN_HISTORY_LABEL: Partial<Record<string, string>> = {
  1: "1時間以内",
  24: "1日以内",
  72: "3日以内",
  168: "1週間以内",
};

export const KNOWLEDGE_BASE_URL = {
  DEFAULT: "https://www.patolo.jp/portal/ja/kb/patolo",
  talentPrice: "https://www.patolo.jp/portal/ja/kb/articles/introduction-fee",
  tip: "https://www.patolo.jp/portal/ja/kb/articles/tipsettlement",
  merchantPrice: "https://www.patolo.jp/portal/ja/kb/articles/agent-charge",
  guidelines: "https://www.patolo.jp/portal/ja/kb/articles/guidelines",
  abroad: "https://www.patolo.jp/portal/ja/kb/articles/abroad",
  NOTIFICATION: "https://www.patolo.jp/portal/ja/kb/articles/notification",
  notificationSettings:
    "https://www.patolo.jp/portal/ja/kb/articles/notification-settings",
  ORDER: "https://www.patolo.jp/portal/ja/kb/articles/order-only",
  BLOCK: "https://www.patolo.jp/portal/ja/kb/articles/block",
  VERIFICATION: "https://www.patolo.jp/portal/ja/kb/articles/honninkakunin",
  PRICE_NEGOTIATION:
    "https://www.patolo.jp/portal/ja/kb/articles/price-negotiation",
  REVERSEOFFERMEN:
    "https://www.patolo.jp/portal/ja/kb/articles/reverseoffermen",
  RESCHEDULE: "https://www.patolo.jp/portal/ja/kb/articles/reschedule",
  DATE_MEN: "https://www.patolo.jp/portal/ja/kb/articles/datemen",
  DIFF_BAISHUN:
    "https://www.patolo.jp/portal/ja/kb/articles/differences-from-prostitution",
  MAN_TYPE: "https://www.patolo.jp/portal/ja/kb/articles/man-type",
  AUTO_DATE_POINT: "https://www.patolo.jp/portal/ja/kb/articles/point#_3",
};

export const LEGAL_INFORMATION_URL = {
  MEMBERSHIP_AGREEMENT: "https://unv.group/terms#patolo",
  PRIVACY_POLICY: "https://unv.group/privacy-policy",
};
export const CONTACT_MAIL_ADDRESS = "contact@patolo.jp";

export const VERIFIED_KYC_STATUS = "ok";
export const VERIFYING_KYC_STATUS = "applying";

export const HTTP_RESPONSE_STATUS_CODE = {
  OK: 200,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  CLIENT_CLOSE_REQUEST: 499, // abort
  INTERNAL_SERVER_ERROR: 500,
} as const;

export type HttpResponseStatusCode =
  (typeof HTTP_RESPONSE_STATUS_CODE)[keyof typeof HTTP_RESPONSE_STATUS_CODE];

export const MAX_FARE = 10_000;
export const MIN_FARE = 0;
